import { Box, TextField, Typography } from '@mui/material';
import { Component, createRef } from 'react';
import AppManager from '../../commun/AppManager';
import { Spinner } from '../../commun/component/Spinner';
import { post } from '../../commun/HTTP';
import Result from '../../commun/Result';
import Toast from '../../commun/toast/Toast';
import { JSXInternal } from 'preact/src/jsx';
import { getErrorMessage } from '../../utils/Error';
import MpModal, { IBaseModalProps } from '../extends/MpModal';

export interface IAddVendorModalProps extends IBaseModalProps {}

export interface IAddVendorModalState {
    name: string;
    loading: boolean;
    error: string;
}

export default class AddVendorModal extends Component<IAddVendorModalProps, IAddVendorModalState> {
    inputRef: React.RefObject<HTMLInputElement>;

    constructor(props: IAddVendorModalProps) {
        super(props);

        this.state = this.initState();
        this.inputRef = createRef();
    }

    initState() {
        const p: IAddVendorModalState = {
            name: '',
            loading: false,
            error: '',
        };
        return p;
    }

    componentDidUpdate(
        prevProps: Readonly<IAddVendorModalProps>,
        prevState: Readonly<IAddVendorModalState>,
        snapshot?: any,
    ): void {
        if (prevProps.open !== this.props.open) {
            this.setState(this.initState());
        }
        if (prevProps.open !== this.props.open && this.props.open) {
            setTimeout(() => {
                this.inputRef.current?.focus();
            });
        }
    }

    addVendor() {
        const { loading, name } = this.state;
        this.setState({
            loading: true,
            error: '',
        });
        post('/vendor/update', {
            name: name,
        }).then((res: any) => {
            this.setState({
                loading: false,
            });
            if (Result.isSuccess(res)) {
                Result.applyResult(res, AppManager.updater(), true);
                this.props.onClose();
                AppManager.addToast(new Toast('Le fournisseur a été ajouté avec succès.', 'success'));
            } else {
                this.setState({
                    error: getErrorMessage(Result.getErrorStr(res)),
                });
            }
        });
    }

    render(): JSXInternal.Element {
        const { open, onClose } = this.props;
        const { loading, name, error } = this.state;
        return (
            <MpModal
                open={open}
                onClose={onClose}
                onSubmit={() => {
                    this.addVendor();
                }}
                title="Ajouter un fournisseur"
                done="Ajouter"
            >
                {loading ? (
                    <Box className="flex items-center justify-center py-12">
                        <Spinner color="blue" className="" />
                    </Box>
                ) : (
                    <Box className="flex flex-col !text-gray-600 gap-2">
                        <Typography className="!text-sm !font-semibold">NOM DU FOURNISSEUR</Typography>
                        <TextField
                            inputProps={{
                                ref: this.inputRef,
                            }}
                            fullWidth
                            value={name}
                            onChange={(e) => {
                                this.setState({ name: (e.target as any).value });
                            }}
                            placeholder="Nom du fournisseur"
                            variant="outlined"
                        />
                        {error !== '' && (
                            <Typography
                                component={'p'}
                                className="!text-sm text-red-600 !mt-1 !mb-1 !font-medium text-center"
                            >
                                {error}
                            </Typography>
                        )}
                    </Box>
                )}
            </MpModal>
        );
    }
}
